var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		("collapsible collapsible--align-" + _vm.alignment),
		{
			'collapsible--expanded': _vm.isOpen,
		} ],attrs:{"data-cy":"collapsible"}},[_c('div',{staticClass:"collapsible__content",class:{
			'collapsible__content--collapsed': !_vm.isOpen,
			'collapsible__content--expanded': _vm.isOpen,
		},style:(_vm.contentStyle)},[_c('div',{ref:"content",staticClass:"collapsible__inner"},[_c('content-watcher',{on:{"loaded":_vm.setElementHeight}},[_vm._t("default")],2)],1)]),(_vm.elementHeight > _vm.height)?[(_vm.ctaType === 'button')?_c('helio-button',{class:[
				'collapsible__cta collapsible__cta--button',
				{
					'collapsible__cta--collapsed': !_vm.isOpen,
					'collapsible__cta--expanded': _vm.isOpen,
				}
			],style:(_vm.buttonStyle),attrs:{"text":_vm.text,"color":"primary"},on:{"click":_vm.toggle}}):(_vm.ctaType === 'text')?_c('div',{class:[
				'collapsible__cta collapsible__cta--text',
				{
					'collapsible__cta--collapsed': !_vm.isOpen,
					'collapsible__cta--expanded': _vm.isOpen,
				}
			],style:(_vm.buttonStyle),on:{"click":_vm.toggle}},[_c('helio-icon',{staticClass:"collapsible__icon",attrs:{"token":"angle-down"}}),_vm._v("\n\n\t\t\t"+_vm._s(_vm.text)+"\n\t\t")],1):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }